import { render } from "./SeWageEmploymentDocs.vue?vue&type=template&id=687efeee&scoped=true"
import script from "./SeWageEmploymentDocs.vue?vue&type=script&lang=js"
export * from "./SeWageEmploymentDocs.vue?vue&type=script&lang=js"

import "./SeWageEmploymentDocs.vue?vue&type=style&index=0&id=687efeee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687efeee"]])

export default __exports__